import { type AcceptQuotePayload } from '../../../modules/moves'
import { type CheckoutFormValues } from './CheckoutForm.type'

type FormatFormOutPutOptions = {
  isLongDistance?: boolean
}

export const formatFormOutput = (values: CheckoutFormValues, { isLongDistance = false }: FormatFormOutPutOptions = {}): AcceptQuotePayload => {
  return {
    selectedTime: isLongDistance ? undefined : values.selectedTime,
    note: values.note !== '' ? values.note : undefined,
  }
}
